<template>
  <!-- 最新资讯 -->
  <div class="dynamic">
    <div class="box">
      <div class="header">
        <div class="title">最新资讯</div>
        <div class="border"></div>
      </div>
      <div class="body">
        <div class="top">
          <div
            class="item"
            v-for="item in dynamicTitleList"
            :key="item.id"
            @click="selectTitle(item.id)"
          >
            <div :class="item.id == titleID ? 'active' : ''">
              {{ item.title }}
            </div>
          </div>
        </div>

        <div class="center">
          <div class="list">
            <div
              class="item"
              v-for="item in titleID == 1 ? dynamicList : dynamicList1"
              :key="item.id"
            >
              <div class="open">
                <router-link :to="{ path: item.path, query: { id: item.id } }">
                  <img :src="item.logo" alt="" />
                  <div class="title">{{ item.title }}</div>
                </router-link>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="bottom">
          <div
            v-for="item in dynamicTitleList"
            :key="item.id"
            :class="titleID == item.id ? 'active' : ''"
            @click="selectTitle(item.id)"
          ></div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import dynamicOpen from "../../../assets/home/dynamicOpen.png";

import newsdetails2 from "../../../assets/dynamic/newsdetails2.png";
import newsdetails3 from "../../../assets/dynamic/newsdetails3.png";
import newsdetails4 from "../../../assets/dynamic/newsdetails4.png";
import newsdetails5 from "../../../assets/dynamic/newsdetails5.png";

import newsdetails7 from "../../../assets/dynamic/newsdetails7.png";
import newsdetails8 from "../../../assets/dynamic/newsdetails8.png";
import newsdetails9 from "../../../assets/dynamic/newsdetails9.png";
import newsdetails10 from "../../../assets/dynamic/newsdetails10.png";

export default {
  setup() {
    return reactive({
      dynamicOpen: dynamicOpen,
      titleID: 1,
      dynamicTitleList: [
        {
          id: 1,
          title: "行业新闻",
        },
        {
          id: 2,
          title: "公司动态",
        },
      ],
      dynamicList: [
        {
          id: 1,
          title: "10大物业管理软件排名",
          logo: newsdetails2,
          path: "/mobile/dynamic/newsdetails",
        },
        {
          id: 2,
          title: "智慧物业管理系统建设智慧社区为何这么受欢迎？",
          logo: newsdetails3,
          path: "/mobile/dynamic/newsdetails",
        },
        {
          id: 3,
          title: "智慧物业管理系统的建设如何解决传统物业管理的“痛点”？",
          logo: newsdetails4,
          path: "/mobile/dynamic/newsdetails",
        },
        {
          id: 4,
          title: "疫情之下，智慧物业管理系统的建设，有了更多的“用武之地”",
          logo: newsdetails5,
          path: "/mobile/dynamic/newsdetails",
        },
      ],
      dynamicList1: [
        {
          id: 1,
          title: "惠阳苑竣工案例",
          logo: newsdetails7,
          path: "/mobile/dynamic/dynamicdetails",
        },
        {
          id: 2,
          title: "香岛原墅小区智能安防系统建设",
          logo: newsdetails8,
          path: "/mobile/dynamic/dynamicdetails",
        },
        {
          id: 3,
          title: "宝山八村高空抛物系统集成服务项目",
          logo: newsdetails9,
          path: "/mobile/dynamic/dynamicdetails",
        },
        {
          id: 4,
          title: "宝山区11个消防救援站WIFI6项目",
          logo: newsdetails10,
          path: "/mobile/dynamic/dynamicdetails",
        },
      ],
    });
  },
  methods: {
    selectTitle(id) {
      this.titleID = id;
    },
  },
};
</script>

<style scoped>
.dynamic {
  background: rgba(243, 244, 248, 0.4);
  padding: 16px 0;
  margin-top: 24px;
}
.dynamic .box {
  width: 92vw;
  margin: 0 auto 0;
}
.header .title {
  font-size: 16px;
  text-align: center;
}
.header .border {
  width: 16px;
  height: 2px;
  background: #248efb;
  margin: 5px auto 0;
}

.body {
  margin-top: 16px;
}
.body .top {
  display: flex;
  justify-content: space-evenly;
}
.body .top .item div {
  font-size: 14px;
  color: #333;
  text-align: center;
  padding: 5px 0;
  cursor: pointer;
}
.body .top .item .active {
  color: #248efb;
  border-bottom: 3px solid #248efb;
}

.center {
  margin-top: 16px;
}
.center .list {
  display: flex;
  flex-wrap: wrap;
}
.center .list .item {
  width: 92vw;
  background-color: #fff;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center;
  margin: 0 auto 20px;
  text-align: center;
}
.center .list .item .open .title {
  width: 266px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  font-size: 14px;
  color: #333;
  margin: 12px auto;
}
.center .list .item .open img {
  width: 100%;
}

.bottom {
  display: flex;
  justify-content: center;
  margin-top: 16px;
}
.bottom div {
  width: 40px;
  height: 6px;
  background: #d8d8d8;
  margin-right: 20px;
}
.bottom .active {
  background-color: #248efb;
}
</style>
